// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterPropertyAddressesWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RenterAddressAutocompleteWebResponseDto } from '../..';

interface AutocompleteParams {
  partialAddress: string;
}

export const CappsRenterPropertyAddressesWebApiHandler_autocomplete_Path =
  '/api/web/renter/v1/properties/addresses/autocomplete';

/**
 * Get autocomplete addresses for a partial address
 */
export const CappsRenterPropertyAddressesWebApiHandler_autocomplete = (
  getParams: AutocompleteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AutocompleteParams, never, RenterAddressAutocompleteWebResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsRenterPropertyAddressesWebApiHandler_autocomplete_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
